import { autoinject } from 'aurelia-framework';
import { OperatorProfileBaseView } from 'General/Views/Dynamic/OperatorProfile/OperatorProfileBaseView';

@autoinject
export class DetailView extends OperatorProfileBaseView { 
    
}